<template>
  <div class="lo-section col-12 col-md-6 col-lg-6 col-xl-6">
      <div class="originator income-box" :class="originator.custom_class">
        <a :href="originator.read_more_link">
          <img class="logo" v-bind:src="getSrc(originator.image)" v-bind:alt="getLogoAlt" v-bind:class="{'logo-smaller' : originator.name == 'ClickCash' || originator.name == 'Finto Capital'}"/>
        </a>
        <h2 class="head">
          <a class="lo-name" :href="originator.read_more_link">{{ originator.name }}</a>
          <img class="lo-flag" v-bind:src="getSrc('flags/' + originator.country + '.svg')" alt="" width="30">
          <img class="lo-flag eu-flag" v-if="originator.isEUFlag" v-bind:src="getSrc('flags/eu.svg')" alt="" width="30">
        </h2>
        <div class="info">
          <span v-html="originator.description"></span>
          <span>&nbsp;</span>
          <br v-if="originator.name === 'Finto Capital'"/>
          <a v-if="originator.read_more_link" v-bind:href=originator.read_more_link class="blue">{{ $t('originatordetails.readMore') }}</a>
        </div>
        <div class="details">
          <div v-if="originator.buyback_guarantee" class="detail">
            <div class="row">
              <div class="col-4">{{ $t('originatordetails.buybackGuarantee') }}</div>
              <div class="col-8">{{ originator.buyback_guarantee }}</div>
            </div>
          </div>
          <div v-if="originator.security" class="detail">
            <div class="row">
              <div class="col-4">{{ $t('originatordetails.security') }}</div>
              <div class="col-8">{{ originator.security }}</div>
            </div>
          </div>
          <div v-if="originator.interest_rate_offered" class="detail">
            <div class="row">
              <div class="col-4">{{ $t('originatordetails.interestRateOffered') }}</div>
              <div class="col-8">{{ originator.interest_rate_offered }}</div>
            </div>
          </div>
          <div v-if="originator.skin_in_the_game" class="detail">
            <div class="row">
              <div class="col-4">{{ $t('originatordetails.juniorShare') }}</div>
              <div class="col-8">{{ originator.skin_in_the_game }}</div>
            </div>
          </div>
        </div>
        <div v-if="originator.presentation_link"><a v-bind:href=originator.presentation_link>{{ $t('originatordetails.presentation') }}</a></div>
      </div>
    <div class="clear" v-if="newline"/>
  </div>
</template>

<script>
import imageMixin from '../mixins/image'

export default {
  name: 'OriginatorDetails',
  props: ['originator', 'newline'],
  mixins: [imageMixin],
  computed: {
    getLogoAlt() {
      return this.originator.logo_alt ? this.originator.logo_alt : this.originator.name
    }
  }
}
</script>

<style scoped lang="scss">
.lo-section {
  box-sizing: border-box;
  border-radius: 10px;
  background-repeat: no-repeat;
  height: auto;
  margin-bottom: 10px;
  margin-top: 5px;
  font-style: normal;

  .originator {
    margin-top: 10px;
    margin-bottom: 10px;
    float: left;

    .logo{
      /*width: 300px;*/
      height: 60px;
      margin-bottom: 30px;
    }
    .logo-smaller {
      height: auto;
      max-height: 60px;
      width: 235px;
      margin-bottom: 48px;
    }

    .head {
      font-style: normal;
      font-weight: bold;
      font-size: 36px;
      line-height: 40px;
      color: #000000;
      margin-bottom: 40px;
    }
    .info {
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 24px;
      color: #6E777A;
      margin-bottom: 40px;
      white-space: pre-wrap;
    }
    .details{
      margin-bottom: 16px;
      margin-top: 16px;

      .detail{
        padding-top: 5px;
        padding-bottom: 5px;
        border-bottom: 1px solid #EDEFF2;

        .col-8{
          text-align: right;
        }
      }
    }
  }
  .clear{
    clear: both;
    margin-bottom: 50px;
  }
  .lo-name {
    color: black;
  }
  .lo-flag {
    margin-left: 5px;
  }
}

@media (min-width: 156px) and (max-width: 1200px) {
  .lo-section {
    .originator {
      .logo {
        max-width: 320px;
      }
    }
  }
}
</style>
